import { useLayoutEffect, useRef } from "react";

// Render previews at a desktop-like viewport so pages don't drop to a
// mobile/squished layout, then scale them down to fit. 1280 is wide enough
// for typical responsive designs to render in their desktop state.
export const DESKTOP_VIEWPORT_WIDTH = 1280;

export const desktopViewportFrameCss = `
  width: calc(100% / var(--preview-scale, 1));
  height: calc(100% / var(--preview-scale, 1));
  transform: scale(var(--preview-scale, 1));
  transform-origin: top left;
`;

export function useDesktopViewportScale<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const apply = () => {
      const scale = Math.min(1, el.clientWidth / DESKTOP_VIEWPORT_WIDTH);
      el.style.setProperty("--preview-scale", String(scale));
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return ref;
}
